import { ThemeEvents } from '@theme/events';

/**
 * Availability Block Component
 * Updates stock level display when variant changes.
 */
class AvailabilityBlock extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    // Scope to this block's section so a foreign availability-block (e.g. a cross-sell card earlier in
    // the fetched page) isn't picked up by a document-wide query. Fall back when no section is found.
    const { html } = event.detail.data;
    const sectionId = this.closest('.shopify-section')?.id;
    const scope = (sectionId && html.querySelector(`#${CSS.escape(sectionId)}`)) || html;
    const newAvailabilityBlock = scope.querySelector('availability-block[ref="availabilityBlock"]');

    if (newAvailabilityBlock) {
      // Show if hidden and update content
      this.hidden = false;
      this.dataset.stockStatus = newAvailabilityBlock.dataset.stockStatus;
      this.className = newAvailabilityBlock.className;

      // Update the text content
      const currentText = this.querySelector('[ref="availabilityText"]');
      const newText = newAvailabilityBlock.querySelector('[ref="availabilityText"]');
      if (currentText && newText) {
        currentText.textContent = newText.textContent;
      }

      // Update the icon (for pill style)
      const currentIcon = this.querySelector('[ref="availabilityIcon"]');
      const newIcon = newAvailabilityBlock.querySelector('[ref="availabilityIcon"]');
      if (currentIcon && newIcon) {
        currentIcon.innerHTML = newIcon.innerHTML;
      }
    } else {
      // No availability block in new HTML (e.g., inventory not managed)
      // Hide this block
      this.hidden = true;
    }
  };
}

if (!customElements.get('availability-block')) {
  customElements.define('availability-block', AvailabilityBlock);
}
